import { EvaluationColor } from '@repo/types';
import { Icon, IconName, Typography } from '@repo/ui';
import c from 'classnames';
import useFeature from 'services/features/useFeature';
import { InsightMetric } from 'types/Insights';
import AssociationsCard from '../SubMetricData/AssociationsCard';
import styles from './SubMetricGraphs.module.css';
import OverTimeCard from './cards/OverTimeCard';
import ResultCard from './cards/ResultCard';
import { getMetricVideo } from './MetricVideo/metricVideos';

const evaluationPillProps: evaluationPillPropsType = {
  green: {
    icon: 'checkVerifiedFilled',
    label: 'Great',
  },
  grey: {
    icon: 'checkFilled',
    label: 'Normal',
  },
  orange: {
    icon: 'alertCircleFilled',
    label: 'Improve',
  },
  red: {
    icon: 'alertTriangleFilled',
    label: 'Support',
  },
};
type evaluationPillPropsType = {
  [key: string]: {
    icon: IconName;
    label: string;
  };
};
export const EvaluationPillFromColor = ({
  evaluation_color,
  showIconOnly = false,
  hideIcon = false,
}: {
  evaluation_color: EvaluationColor;
  showIconOnly?: boolean;
  hideIcon?: boolean;
}) => {
  const defaultEvaluationPillProps = {
    icon: 'infoCircleFilled' as IconName,
    label: 'Other results',
  };
  const { icon, label } =
    evaluationPillProps[evaluation_color] || defaultEvaluationPillProps;
  return (
    <div className='flex'>
      {showIconOnly ? (
        <div className={c(styles.icon, styles[evaluation_color])}>
          <Icon name={icon} />
        </div>
      ) : (
        <div
          className={c(
            styles.pill,
            hideIcon && styles.iconHidden,
            styles[evaluation_color],
          )}
        >
          {!hideIcon && (
            <div className={c(styles.icon, styles[evaluation_color])}>
              <Icon name={icon} />
            </div>
          )}
          <div className='flex'>
            <Typography
              variant={'label'}
              className='m-auto'
              color={evaluation_color}
            >
              {label}
            </Typography>
          </div>
        </div>
      )}
    </div>
  );
};

const SubMetricGraphs = ({ metric }: { metric: Partial<InsightMetric> }) => {
  const { isFeatureEnabled: isMetricVideosEnabled } = useFeature(
    'metrics_educational_videos',
  );
  if (!metric) return <></>;

  const video = isMetricVideosEnabled ? getMetricVideo(metric) : null;

  return (
    <div className='flex flex-column gap-3'>
      <ResultCard metric={metric} video={video} />
      <AssociationsCard
        metricName={metric.name ?? 'The metric'}
        associations={metric.gut_vaginal_health_associations}
      />
      {metric.data_type !== 'string' && !!metric.graph_display && (
        <OverTimeCard metric={metric} />
      )}
    </div>
  );
};
export default SubMetricGraphs;
